export const LOADER_PLAN_ACCION        =       'LOADER_PLAN_ACCION';
export const GET_PLAN_ACCION           =       'GET_PLAN_ACCION';
export const PLAN_ACCION_FALLA          =       'PLAN_ACCION_FALLA';
export const SAVE_LOADER_PLAN_ACCION     =       'SAVE_LOADER_PLAN_ACCION';
export const FORM_PLAN_ACCION_FAIL      =       'FORM_PLAN_ACCION_FAIL';

